import { contentFetch } from "../contentClient.js";
import {
    resolveScopedIdArgs,
    resolveScopedLinkArgs,
    resolveScopedLinkPayloadArgs,
    resolveScopedListArgs,
    resolveScopedMutationArgs,
    resolveScopedPayloadArgs,
    resolveScopedRenameArgs,
} from "./scope.js";

// ============= Parameter Groups API (v2) =============

const base = (projectId, versionId) =>
    `/api/v2/projects/${projectId}/versions/${versionId}/parameter-groups`;

export async function getParameterGroups({ projectId, versionId, search, parentGroupId, page = 1, pageSize } = {}, init) {
    ({ args: { projectId, versionId, search, parentGroupId, page, pageSize }, init } = resolveScopedListArgs({ projectId, versionId, search, parentGroupId, page, pageSize }, init));
    const params = { page };
    if (pageSize) params.pageSize = pageSize;
    if (search?.trim()) params["filter.systemName:contains"] = search.trim();
    if (parentGroupId) params["filter.parentGroupId"] = parentGroupId;
    return contentFetch(base(projectId, versionId), { params, ...(init || {}) });
}

export async function getParameterGroupById(projectId, versionId, id, init) {
    ({ projectId, versionId, id, init } = resolveScopedIdArgs(projectId, versionId, id, init));
    return contentFetch(`${base(projectId, versionId)}/${id}`, init);
}

export async function createParameterGroup(projectId, versionId, payload, init) {
    ({ projectId, versionId, payload, init } = resolveScopedPayloadArgs(projectId, versionId, payload, init));
    // payload: { systemName, name, description?, parentGroupId?, orderIndex?, autoApplyForEntityTypes? }
    return contentFetch(base(projectId, versionId), {
        method: "POST",
        body: payload,
        ...(init || {}),
    });
}

export async function patchParameterGroup(projectId, versionId, id, payload, init) {
    ({ projectId, versionId, id, payload, init } = resolveScopedMutationArgs(projectId, versionId, id, payload, init));
    // payload: { name?, description?, parentGroupId?, orderIndex?, autoApplyForEntityTypes? }
    // record UpdateParameterGroupRequest(
    //      string? Name = null,
    //      string? Description = null,
    //      Guid? ParentGroupId = null,
    //      IReadOnlyList<string>? AutoApplyForEntityTypes = null,
    //      int? OrderIndex = null);
    return contentFetch(`${base(projectId, versionId)}/${id}`, {
        method: "PUT",
        body: payload,
        ...(init || {}),
    });
}

export async function renameParameterGroupSystemName(projectId, versionId, id, newSystemName, init) {
    ({ projectId, versionId, id, newSystemName, init } = resolveScopedRenameArgs(projectId, versionId, id, newSystemName, init));
    return contentFetch(`${base(projectId, versionId)}/${id}:rename`, {
        method: "POST",
        body: { newSystemName },
        ...(init || {}),
    });
}

export async function deleteParameterGroup(projectId, versionId, id, init) {
    ({ projectId, versionId, id, init } = resolveScopedIdArgs(projectId, versionId, id, init));
    return contentFetch(`${base(projectId, versionId)}/${id}`, {
        method: "DELETE",
        ...(init || {}),
    });
}

// --- Parameters within a group ---

export async function getParameterGroupParameters(projectId, versionId, id, init) {
    ({ projectId, versionId, id, init } = resolveScopedIdArgs(projectId, versionId, id, init));
    return contentFetch(`${base(projectId, versionId)}/${id}/parameters`, init);
}

export async function attachParameterToGroup(projectId, versionId, id, payload, init) {
    ({ projectId, versionId, id, payload, init } = resolveScopedMutationArgs(projectId, versionId, id, payload, init));
    // payload: { parameterId, orderIndex?, isRequired? }
    return contentFetch(`${base(projectId, versionId)}/${id}/parameters`, {
        method: "POST",
        body: payload,
        ...(init || {}),
    });
}

export async function patchParameterGroupLink(projectId, versionId, id, linkId, payload, init) {
    ({ projectId, versionId, id, linkId, payload, init } = resolveScopedLinkPayloadArgs(projectId, versionId, id, linkId, payload, init));
    // payload: { orderIndex?, isRequired? }
    return contentFetch(`${base(projectId, versionId)}/${id}/parameters/${linkId}`, {
        method: "PATCH",
        body: payload,
        ...(init || {}),
    });
}

export async function detachParameterFromGroup(projectId, versionId, id, linkId, init) {
    ({ projectId, versionId, id, linkId, init } = resolveScopedLinkArgs(projectId, versionId, id, linkId, init));
    return contentFetch(`${base(projectId, versionId)}/${id}/parameters/${linkId}`, {
        method: "DELETE",
        ...(init || {}),
    });
}
